import React from "react";
import ReportSmryByPartners from "../../../features/reports/rcs/report-smry-partners/components/ReportSmryByPartners";
const _ReportsSmryByPartners = () => {
  return (
    <div className="my-1">
      <h2>Resumen RCS del Partner</h2>
      <ReportSmryByPartners />
    </div>
  );
};

export default _ReportsSmryByPartners;
